// extracted by mini-css-extract-plugin
export default {"Taskbar":"Taskbar_Taskbar__N6Ubt"};